import { render } from "./Alert4.vue?vue&type=template&id=4cd69422"
import script from "./Alert4.vue?vue&type=script&lang=js"
export * from "./Alert4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__